import { render, staticRenderFns } from "./MatrEdit.vue?vue&type=template&id=2aba26cd&scoped=true&"
import script from "./MatrEdit.vue?vue&type=script&lang=js&"
export * from "./MatrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aba26cd",
  null
  
)

export default component.exports